/**
 * URL canônica do cluster de páginas de um ensaio.
 *
 * Por quê: `index` e `photo` são literalmente a mesma página (mesmo componente
 * Photos, mesmos seoTitle/seoDescription) e `perfil`, `wallpaper` e `credits`
 * são fatias finas do mesmo ensaio. Sem consolidação o Google escolhe a canônica
 * sozinho ou não indexa — ~1.900 URLs nesse estado no GSC em 18/08/2026.
 *
 * Aponta para `/photo` — é a URL que concentra o histórico de cliques — e
 * **preserva o idioma da rota**: `/en` canonicaliza para `/en`, nunca para
 * pt-br, senão a árvore inteira em inglês é jogada fora enquanto o próprio
 * hreflang da página declara que ela existe.
 *
 * Ignora query string (as páginas aceitam `?preview=true` e `?partner=`, que não
 * geram URL indexável). Host de produção hardcoded, para dev/staging nunca
 * vazarem como canônica.
 */
export function useModelCanonical(
  modelName: string | string[],
  language: string | string[],
): string {
  const name = Array.isArray(modelName) ? modelName[0] : modelName;
  return `https://belladasemana.com.br/${normalizeLanguage(language)}/modelos/${name}/photo`;
}

/**
 * URL canônica das sub-rotas que mantêm canônica própria (`video`, `making-of`,
 * `live`): title e conteúdo distintos, destino de busca próprio e candidatas a
 * rich result de vídeo quando houver URL de mídia pública.
 */
export function useModelSubpageCanonical(
  modelName: string | string[],
  language: string | string[],
  subpage: "video" | "making-of" | "live",
): string {
  const name = Array.isArray(modelName) ? modelName[0] : modelName;
  return `https://belladasemana.com.br/${normalizeLanguage(language)}/modelos/${name}/${subpage}`;
}

function normalizeLanguage(language: string | string[]): "pt-br" | "en" {
  const lang = Array.isArray(language) ? language[0] : language;
  return lang === "en" ? "en" : "pt-br";
}
